module.exports = __webpack_public_path__ + "img/graph.a68ec481.png";